module.exports = __webpack_public_path__ + "05_long_brown.e368ca7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_long_brown.png
// module id = eJum
// module chunks = 0